import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

const CourseCurriculum = ({ curriculumData, title }) => {
    if (!curriculumData || curriculumData.length === 0) {
        return <Typography>No curriculum available</Typography>;
    }

    return (
        <Box sx={{ p: 3, background: "#ffffff", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0,0,0,0.08)" }}>
            <Typography variant="h3" fontWeight="bold" sx={{ mb: 2, color: "#218838" }}>
                Course Curriculum
            </Typography>

            <Typography variant="h5" fontWeight="bold" sx={{ color: "#ffb300", mb: 2 }}>
                {title} Curriculum
            </Typography>

            {curriculumData.map((section, index) => (
                <Box key={index} sx={{ mb: 3 }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: "#333", mb: 1 }}>
                        {section.title}
                    </Typography>
                    <List sx={{ paddingLeft: 2 }}>
                        {section.topics.map((topic, idx) => (
                            <ListItem key={idx} sx={{ py: 1, pl: 2, position: "relative" }}>
                                <ListItemText primary={topic}  primaryTypographyProps={{ fontSize: "16px", color: "#444", fontWeight: "500" }} />
                                <Box sx={{
                                    position: "absolute",
                                    left: 0,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    width: "6px",
                                    height: "6px",
                                    backgroundColor: "#218838",
                                    borderRadius: "50%",
                                }} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            ))}
        </Box>
    );
};

export default CourseCurriculum;
